import { BackendRoute } from '../../../../config/index';
import { QueryKey } from '../../../../constants/query-key.const';
import { useAppQuery } from '../../../../hooks/use-app-query.hook';
import ApiService from '../../../../services/api-service.util';

export const useReviewSignatureDocument = (signatureId: string, enabled: boolean) => {
  const { data, isPending, isError } = useAppQuery<string>({
    queryKey: [QueryKey.GET_SIGNATURE_PREVIEW, signatureId],
    queryFn: async () => {
      return ApiService.fetchFileUrl({
        endpoint: BackendRoute.SIGNATURES,
        routePath: [signatureId, 'preview'],
      });
    },
    enabled: enabled && !!signatureId,
  });

  return { isError, isPending, previewUrl: data };
};
